const DATE_FORMATTER = new Intl.DateTimeFormat("pt-BR", {
  day: "2-digit",
  month: "short",
  year: "numeric",
})

const DATE_SHORT_FORMATTER = new Intl.DateTimeFormat("pt-BR", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
})

const DATETIME_FORMATTER = new Intl.DateTimeFormat("pt-BR", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
})

export function formatDate(value: string | Date | null | undefined): string {
  if (!value) return "—"
  const date = parseLocalDate(value)
  if (Number.isNaN(date.getTime())) return String(value)
  return DATE_FORMATTER.format(date)
}

/** Data compacta em dd/MM/yyyy (ex.: 04/04/2026), para economizar espaço em tabelas. */
export function formatDateShort(value: string | Date | null | undefined): string {
  if (!value) return "—"
  const date = parseLocalDate(value)
  if (Number.isNaN(date.getTime())) return String(value)
  return DATE_SHORT_FORMATTER.format(date)
}

export function formatDateTime(
  value: string | Date | null | undefined
): string {
  if (!value) return "—"
  const date = parseLocalDate(value)
  if (Number.isNaN(date.getTime())) return String(value)
  return DATETIME_FORMATTER.format(date)
}

export function getInitials(input: string | null | undefined): string {
  if (!input) return "?"
  const parts = input
    .trim()
    .split(/\s+/)
    .filter(Boolean)
  if (!parts.length) return "?"
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase()
  }
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

export function diffDaysFromToday(value: string | Date | null | undefined): number | null {
  if (!value) return null
  const date = parseLocalDate(value)
  if (Number.isNaN(date.getTime())) return null
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  date.setHours(0, 0, 0, 0)
  const ms = date.getTime() - today.getTime()
  return Math.round(ms / (1000 * 60 * 60 * 24))
}

/**
 * Diferença em dias inteiros entre a entrega e o prazo.
 * Positivo → entregue ANTES do prazo (dias de antecedência).
 * Negativo → entregue DEPOIS do prazo (dias de atraso).
 */
export function deliveryDelta(
  entregue: string | Date | null | undefined,
  prazo: string | Date | null | undefined
): number | null {
  if (!entregue || !prazo) return null
  const entregueDate = parseLocalDate(entregue)
  const prazoDate = parseLocalDate(prazo)
  if (Number.isNaN(entregueDate.getTime()) || Number.isNaN(prazoDate.getTime())) {
    return null
  }
  entregueDate.setHours(0, 0, 0, 0)
  prazoDate.setHours(0, 0, 0, 0)
  const ms = prazoDate.getTime() - entregueDate.getTime()
  return Math.round(ms / (1000 * 60 * 60 * 24))
}

function parseLocalDate(value: string | Date): Date {
  if (value instanceof Date) return new Date(value)

  const dateOnlyMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value)
  if (dateOnlyMatch) {
    const [, year, month, day] = dateOnlyMatch
    return new Date(Number(year), Number(month) - 1, Number(day))
  }

  return new Date(value)
}
